import { Modal } from 'antd'
import axios from 'axios'
import { getUserInfo } from '@/utils/common'
import env from '@/config/env'

export const allRequestAddJxsxx = (request) => {
  const userinfo = getUserInfo()
  if(['/jxs/user/login', '/jxs/user/currentUser'].includes(request.url)) {
    return request
  }
  if(!request.params) {
    request.params = {}
  }
  if((request as any).ssgsbm !== false && userinfo && userinfo.jxsxx && userinfo.jxsxx.ssgsbm) {
    request.params.ssgsbm = 2200
  }
  return request
}

export const responseError = (response) => {
  if(response.status === 200) {
    Modal.warning({
      title: '提示',
      content: ''
    })
  }
}

const http = axios.create({
  baseURL: env.BASE_URL,
  withCredentials: true,
})

http.interceptors.request.use(allRequestAddJxsxx)

http.interceptors.response.use((response) => {
  if((response.config as any).autopass) {
    return response.data
  }
  if(!(response.config as any).uncheck && (!['succeed', 'ok'].includes(response.data.status) && !response.data.success)) {
    Modal.warning({
      title: '提示',
      content: response.data.msg || response.data.errmsg || '处理异常，请稍后再试'
    })
  }
  return response.data
})

const request = (url, params={}) => {
  return http(url, params) as Promise<any>
}

export default request
